import { BaseSensor } from './BaseSensor';
import { Device } from './Device';
import { TranslationService } from '../services/translation.service';
export class HeatingCircuit extends Device{
	private internal_id=0;
	static _id:number;
	translator:TranslationService;
	getId(){
		return this.id;
	}
	constructor(id:number){
		super(id);
		this.translator = TranslationService.getInstance();
		this.internal_id = HeatingCircuit._id;
		HeatingCircuit._id++;
		this.id=id;
		this.scales = new Map<string,BaseSensor>();
		this.values = new Map<string,string>();
	
		this.values.set('circuitType','ENUM_TYPE_OF_CIRCUIT_HEATING');
		this.values.set('circuitState','ENUM_CIRCUIT_STATUS_STANDBY');

		this.scales.set("vorlaufsolltemp",BaseSensor.fromArgs("vorlaufsolltemp",0,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("vorlaufisttemp",BaseSensor.fromArgs("vorlaufisttemp",31,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		

		this.scales.set("at_abschaltgrenze",BaseSensor.fromArgs("at_abschaltgrenze",21,10,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("vorlaufsolltemp_wunsch",BaseSensor.fromArgs("vorlaufsolltemp_wunsch",65,5,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("vorlaufsolltemp_absenkwunsch",BaseSensor.fromArgs("vorlaufsolltemp_absenk",0,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("warmwassertemperatur",BaseSensor.fromArgs("warmwassertemperatur",60,35,70,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("speicher_ist_temperatur",BaseSensor.fromArgs("speicher_ist_temperatur",31,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("rücklauf_soll_temperatur",BaseSensor.fromArgs("rücklauf_soll_temperatur",30,15,80,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("heizkurve",BaseSensor.fromArgs("heizkurve",1.2,0.1,4,0.05,""));
		this.scales.set("min_vorlauf_soll_temperatur",BaseSensor.fromArgs("min_vorlauf_soll_temperatur",15,15,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("max_vorlauf_soll_temperatur",BaseSensor.fromArgs("max_vorlauf_soll_temperatur",90,15,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.values.set('absenkmodus','ENUM_AUTO_OFF_MODE_ECO');
		this.values.set('raumaufschaltung','ENUM_ROOM_TEMPERATURE_INFLUENCE_NON');
		this.values.set('kuehlen_moeglich','ENUM_COOLING_ALLOWED_NO');
		this.values.set('taupunktüberwachung','ENUM_DEW_POINT_MONITORING_YES');

		this.scales.set("min_vorlauftemp_kuehlen",BaseSensor.fromArgs("min_vorlauftemp_kuehlen",20,7,24,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("offset_taupunkt",BaseSensor.fromArgs("offset_taupunkt",2,-10,10,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.values.set('externe_waermeanforderung','ENUM_STATUS_EXTERNAL_HEAT_DEMAND_OFF');
		this.values.set('status_pumpe','ENUM_CIRCUIT_PUMP_STATUS_OFF');

		this.scales.set("status_mischventil",BaseSensor.fromArgs("status_mischventil",0,0,100,1,"STD_UNIT_PERCENT_NORMAL_LEFT"));

		this.scales.set("estrichtTrocknungsTag",BaseSensor.fromArgs("estrichtTrocknungsTag",0,0,29,1,""));
	}

	getScale(key:string):BaseSensor{
		return this.scales.get(key);
	}
	getScaleValue(key:string){
		return this.scales.get(key).getCurrentValue();
	}
	
	setValue(key:string,value:string){
		this.values.set(key,value);
	}
	getValue(key){
		return this.translator.tr(this.values.get(key));
	}
	getRawValue(key){
		return this.values.get(key);
	}
	hasValue(key){
		return this.values.has(key);
	}
	hasScale(key){
		return this.scales.has(key);
	}

}